/**
 * 性别
 */
export default Object.freeze({
    MALE: '男', // 男
    FEMALE: '女' // 女
})